import { HelpResourceMap } from './InfoIcon.types';

export const helpResources: HelpResourceMap = {
  'user-profile': {
    title: 'User Profile Help',
    content: `# User Profile
    
Your user profile contains your personal information and preferences.
- Profile picture
- Contact information
- Account settings`
  },
  'dashboard': {
    title: 'Dashboard Overview',
    content: `# Dashboard
    
The dashboard provides an overview of your key metrics and activities.
- Recent activity
- Statistics
- Quick actions`
  },
  'video-guide': {
    title: 'Video Guide Information',
    content: `# About This Video Guide

This tutorial video provides a comprehensive overview of the system's features and functionality.

## What You'll Learn
- Basic navigation and interface overview
- Key features and their usage
- Best practices and tips
- Common troubleshooting steps

## Duration
The video is approximately 10 minutes long and includes interactive timestamps for easy navigation.`
  }
}; 